<template>
  <div>
    <div ref="chartdiv" style="height: 400px; border: 1px solid #c5c5c5; margin-top: 18px"></div>
    <b-form-tags v-model="countries_selected" no-outer-focus class="mb-2">
      <template v-slot="{ tags }">
        <!-- <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
        <b-input-group class="mb-2">
          <b-form-input
            v-bind="inputAttrs"
            v-on="inputHandlers"
            placeholder="New country - Input proper country name"
            class="form-control"
            list="my-list-id"
            @input="onCountryInput"
          ></b-form-input>
          <datalist id="my-list-id">
            <option
              v-for="country_tip in country_suggest"
              v-bind:key="country_tip.name"
            >{{ country_tip.name }}</option>
          </datalist>
          <b-input-group-append>
            <b-button @click="addTag" variant="primary" :disabled="!country_check">Add</b-button>
          </b-input-group-append>
        </b-input-group>-->
        <div class="d-inline-block" style="font-size: 1.5rem;">
          <b-form-tag
            v-for="country in tags"
            :key="country"
            :title="country"
            variant="success"
            class="mb-2"
            no-add-on-enter
          >
            <i class="ni ni-pin-3"></i>
            {{ country }}
          </b-form-tag>
        </div>
      </template>
    </b-form-tags>
  </div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4maps from "@amcharts/amcharts4/maps";

import am4themes_dataviz from "@amcharts/amcharts4/themes/dataviz";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";

import countries from "./countries.js";
// Themes begin
am4core.useTheme(am4themes_dataviz);
am4core.useTheme(am4themes_animated);

export default {
  name: "components",
  components: {},
  data() {
    return {
      country_list: [],
      chart: null,
      country_suggest: ["a", "b"],
      country_check: true,
    };
  },
  props: {
    countries_selected: {
      type: Array,
    },
  },
  mounted() {
    this.prepareMap();
  },
  watch: {
    countries_selected: function(newVal, oldVal) { // watch it
      if(oldVal.length == 0)
        this.prepareMap();
    }
  },
  methods: {
    prepareMap() {
      // Create map instance
      let vm = this;
      let chart = am4core.create(this.$refs.chartdiv, am4maps.MapChart);

      // Set map definition
      chart.geodata = am4geodata_worldLow;

      // Set projection
      chart.projection = new am4maps.projections.NaturalEarth1();

      // Create map polygon series
      var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
      polygonSeries.mapPolygons.template.strokeWidth = 0.5;

      // Exclude Antartica
      polygonSeries.exclude = ["AQ"];

      // Make map load polygon (like country names) data from GeoJSON
      polygonSeries.useGeodata = true;

      // Configure series
      var polygonTemplate = polygonSeries.mapPolygons.template;
      polygonTemplate.tooltipText = "{name}";
      polygonTemplate.fill = chart.colors.getIndex(0);

      // Create hover state and set alternative fill color
      var hs = polygonTemplate.states.create("hover");
      hs.properties.fill = chart.colors.getIndex(5);
      // Create active state
      var activeState = polygonTemplate.states.create("active");
      activeState.properties.fill = chart.colors.getIndex(4);

      // Create an event to toggle "active" state
      polygonTemplate.events.on("hit", this.clickOnMap);
      polygonTemplate.events.on("ready", this.readyMap);

      polygonTemplate.propertyFields.fill = "fill";
      var graticuleSeries = chart.series.push(new am4maps.GraticuleSeries());

      this.chart = chart;

      this.country_suggest = countries;
    },
    readyMap(ev) {
      var data = ev.target.dataItem.dataContext;
      for (var i in this.countries_selected) {
        if (this.countries_selected[i] == data.name) ev.target.isActive = true;
      }
    },
    clickOnMap(ev) {
      ev.target.isActive = !ev.target.isActive;
      var data = ev.target.dataItem.dataContext;
      //this.country_list.push([data.id, data.name, ev.target.isActive]);
      if (ev.target.isActive) {
        this.countries_selected.push(data.name);
      } else {
        for (var i = 0; i < this.countries_selected.length; i++) {
          if (this.countries_selected[i] == data.name)
            this.countries_selected.splice(i, 1);
        }
      }
      //   console.log(this.country_list);
      //   console.log(this.chart.series);
      // add_country_tag();
      console.log(this.countries_selected);
    },
    country_validator(country_name) {
      return country_name.length > 2 && country_name.length < 6;
    },
    addTag() {
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
};
</script>
